import React from "react";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";
import JobUpdateModal from "src/Components/JobUpdateModal";

const JobsTable = ({
  data,
  columns,
  options,
  updateJobVisible,
  setUpdateJobVisible,
  selectedJobId,
  venders,
  customers,
  jobTypes,
  getData
}) => {
  return (
    <div className="container">
      <CustomMuiDataTable
        title={"Jobs"}
        data={data}
        columns={columns}
        options={options}
      />
      <JobUpdateModal
        open={updateJobVisible}
        onClose={() => setUpdateJobVisible(false)}
        jobId={selectedJobId}
        venders={venders}
        customers={customers}
        jobTypes={jobTypes}
        onSuccess={getData}
      />
    </div>
  );
};

export default JobsTable; 